import { MasterKeyContainer } from '../../rightSidebar/masterKey/masterKey.container';

export const MasterKeyToolContainer = () => {
  return (
    <MasterKeyContainer allowShowTabs={false} allowScrollbar={false} />
  );
};
